import { Routes } from '@angular/router';
import { Home } from './pages/home/home';
import { Login } from './pages/login/login';
import { AuthCallback } from './pages/auth-callback/auth-callback';
import { ProjectLayout } from './pages/projects/project-layout';
import { ProjectsList } from './pages/projects-list/projects-list';
import { ProjectHome } from './pages/project-home/project-home';
import { Roles } from './pages/project-config/roles/roles';
import { RoleForm } from './pages/project-config/roles/role-form';
import { RoleDetail } from './pages/project-config/roles/role-detail';
import { Agents } from './pages/project-config/agents/agents';
import { AgentForm } from './pages/project-config/agents/agent-form';
import { AgentDetail } from './pages/project-config/agents/agent-detail';
import { Workflows } from './pages/project-config/workflows/workflows';
import { Tools } from './pages/project-config/tools/tools';
import { AccessPermissions } from './pages/project-security/access-permissions/access-permissions';
import { authGuard } from './guards/auth.guard';
import { unsavedDraftGuard } from './guards/unsaved-draft.guard';
import { Signup } from './pages/signup/signup';

export const routes: Routes = [
    { path: 'login', component: Login, title: 'Login – WorkGraph' },
    { path: 'signup', component: Signup, title: 'Sign Up – WorkGraph' },
    { path: 'auth/callback', component: AuthCallback, title: 'Signing In...' },
    {
        path: 'dashboard',
        component: ProjectsList,
        title: 'My Projects – WorkGraph',
        canActivate: [authGuard],
    },
    {
        path: 'projects/:projectId',
        component: ProjectLayout,
        canActivate: [authGuard],
        children: [
            { path: '', component: ProjectHome, title: 'Project Dashboard' },
            { path: 'agents', component: Agents, title: 'Agents' },
            { path: 'agents/new', component: AgentForm, title: 'New Agent' },
            { path: 'agents/:agentId', component: AgentDetail, title: 'Agent' },
            { path: 'agents/:agentId/edit', component: AgentForm, title: 'Edit Agent' },
            { path: 'roles', component: Roles, title: 'Roles' },
            { path: 'roles/new', component: RoleForm, title: 'New Role' },
            { path: 'roles/:roleId', component: RoleDetail, title: 'Role' },
            { path: 'roles/:roleId/edit', component: RoleForm, title: 'Edit Role' },
            { path: 'workflows', component: Workflows, title: 'Workflows' },
            {
                path: 'workflows/:workflowId',
                loadComponent: () =>
                    import('./pages/project-config/workflows/editor/workflow-editor').then(
                        (m) => m.WorkflowEditor,
                    ),
                canDeactivate: [unsavedDraftGuard],
                title: 'Workflow',
            },
            { path: 'tools', component: Tools, title: 'Tools' },
            {
                path: 'access-permissions',
                component: AccessPermissions,
                title: 'Access & Permissions',
            },
        ],
    },
    { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
    { path: '**', redirectTo: '/dashboard' },
];
